import { render, staticRenderFns } from "./ViewAllRecomendedCourses.html?vue&type=template&id=58673489&scoped=true&"
import script from "./ViewAllRecomendedCourses.vue?vue&type=script&lang=js&"
export * from "./ViewAllRecomendedCourses.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllRecomendedCourses.scss?vue&type=style&index=0&id=58673489&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58673489",
  null
  
)

export default component.exports